import { render, staticRenderFns } from "./invite-user.vue?vue&type=template&id=dba88f30"
import script from "./invite-user.vue?vue&type=script&lang=ts"
export * from "./invite-user.vue?vue&type=script&lang=ts"
import style0 from "./invite-user.vue?vue&type=style&index=0&id=dba88f30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports